module.exports = __webpack_public_path__ + "static/media/goSchoolZone_zh.28d3e3ce.png";